export class Task {
  id: number;
  description: string;
  priority: number;
  user: string;
  schoolName: string;
  serviceName: string;
  status: number;
  statusDescription: string;
  startDate: Date;
  endDate: Date;
  profitCenterCode: string;
  resultUrl: string;
  month: number;
  year: number;
}

export class TaskAddModel {
  taskTypeId: number;
  month: number;
  year: number;
  zoneId: number;
  serviceId: number;
  ceco: string;
  schoolId: number;
}

export class TaskAddRequest {
  taskTypeId: number;
  month: number;
  year: number;
  zoneId: number;
  serviceId: number;
  ceco: string;
  schoolId: number;
}

export class TaskTypeToList {
  id: number;
  description: string;
}

export class TaskTypeToCreate {
  id: number;
  description: string;
  needZone: boolean;
  needMonth: boolean;
  needYear: boolean;
  needDate: boolean;
  needService: boolean;
  needCenter: boolean
}

export class CreateTaskResponse {
  statusCode: number;
  reason: string;
  month: number;
  year: number;
  schoolId: number;
}
